import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LanguageContext from 'context/LanguageContext';

import { ImLinkedin } from 'react-icons/im';
import { FiMail, FiPhone } from 'react-icons/fi';

import Logo from '../../assets/logo_inverse.png';

function Footer() {
  const { language } = useContext(LanguageContext);

  const footerLink = [
    {
      heading: 'Sito Web',
      submenu: [
        {
          title: 'Home',
          href: '/',
        },
        {
          title: 'Azienda',
          href: '/company',
        },
        {
          title: 'Personale',
          href: '/team',
        },
        {
          title: 'Prodotti',
          href: '/prodotti/',
        },
        {
          title: 'Carriera',
          href: '/carriera',
        },
        // {
        //   title: 'News',
        //   href: '/news',
        // },
      ],
    },
    {
      heading: 'Servizi',
      submenu: [
        {
          title: 'Ingegneria',
          href: '/servizi',
        },
        {
          title: 'Progettazione',
          href: '/servizi#',
        },
        {
          title: 'Progetti',
          href: '/progetti',
        },
      ],
    },
    {
      heading: 'Contatti',
      submenu: [
        {
          icon: <FiMail className="w-4 h-4" />,
          title: 'info@edrivelab.it',
          href: 'mailto:info@edrivelab.it',
        },
        {
          icon: <FiPhone className="w-4 h-4" />,
          title: '+39 0521 179 0027',
          href: 'telto:+3905211790027',
        },
        // {
        //   icon: <FiMapPin className="w-4 h-4" />,
        //   title: 'Via Giuseppe di Vittorio, 60 - Lemignano di Collecchio (PR)',
        //   href: 'https://goo.gl/maps/nR5cfqaxsXbtZBzE6',
        // },
      ],
    },
  ];
  const footerLinkEn = [
    {
      heading: 'Web Site',
      submenu: [
        {
          title: 'Home',
          href: '/',
        },
        {
          title: 'Company',
          href: '/company',
        },
        {
          title: 'Team',
          href: '/team',
        },
        {
          title: 'Products',
          href: '/products',
        },
        {
          title: 'Careers',
          href: '/careers',
        },
        // {
        //   title: 'News',
        //   href: '/news',
        // },
      ],
    },
    {
      heading: 'Services',
      submenu: [
        {
          title: 'Engineering',
          href: '/services',
        },
        {
          title: 'Design',
          href: '/services',
        },
        {
          title: 'Projects',
          href: '/projects',
        },
      ],
    },
    {
      heading: 'Contacts',
      submenu: [
        {
          icon: <FiMail className="w-4 h-4" />,
          title: 'info@edrivelab.it',
          href: 'mailto:info@edrivelab.it',
        },
        {
          icon: <FiPhone className="w-4 h-4" />,
          title: '+39 0521 179 0027',
          href: 'telto:+3905211790027',
        },
        // {
        //   icon: <FiMapPin className="w-4 h-4" />,
        //   title: 'Via Giuseppe di Vittorio, 60 - Lemignano di Collecchio (PR)',
        //   href: 'https://goo.gl/maps/nR5cfqaxsXbtZBzE6',
        // },
      ],
    },
  ];

  const social = [
    {
      icon: <ImLinkedin className="w-6 h-6 fill-white" />,
      title: 'LinkedIn',
      href: 'https://www.linkedin.com/company/edrivelab/',
    },
  ];

  return (
    <footer className="bg-gray-800">
      <div className="container px-10 pt-16 pb-6 mx-auto md:px-10 sm:px-6 lg:px-10 lg:pt-24">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex justify-start text-white sm:justify-start">
              <Link to="/">
                <img src={Logo} alt="" className="w-20" />
              </Link>
            </div>

            <p className="max-w-md mt-6 leading-relaxed text-left text-white sm:max-w-xs sm:mx-0">
              eDriveLAB s.r.l.
              <br />
              Via Giuseppe di Vittorio, 60
              <br />
              Lemignano di Collecchio (PR)
              <br />
              P.IVA: IT02831090341
              <br />
              Numero REA: PR - 270398
              <br />
            </p>
            <ul className="flex justify-start gap-6 mt-8 md:gap-8 sm:justify-start ">
              {social &&
                social.map((social, id) => (
                  <a href={social.href} target="_blank" rel="noreferrer">
                    <li key={id}>{social.icon}</li>
                  </a>
                ))}
            </ul>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:gap-8 sm:grid-cols-3 lg:col-span-2 md:grid-cols-3 md:col-span-2">
            {language == 'it'
              ? footerLink.map((section, id) =>
                  id < footerLink.length - 1 ? (
                    <div className="">
                      <div
                        className={
                          id < footerLink.length - 1
                            ? 'pb-6 text-left border-b sm:border-none sm:text-left w-fit'
                            : ''
                        }
                      >
                        <p className="text-lg font-medium text-white">
                          {section.heading}
                        </p>
                        <nav className="mt-4">
                          <ul className="space-y-4 text-sm">
                            {section.submenu &&
                              section.submenu.map((submenu, id) => (
                                // TODO: trovare il modo di cambiare il Link in un a tag
                                // per l'ultimo elemento dell'array
                                <Link to={submenu.href}>
                                  <li
                                    id={id}
                                    className={
                                      submenu.icon
                                        ? `mt-3 text-white flex items-center justify-start gap-2`
                                        : `mt-3 text-white`
                                    }
                                  >
                                    {submenu.icon ? (
                                      <span className="w-auto">
                                        {submenu.icon}
                                      </span>
                                    ) : (
                                      ''
                                    )}
                                    <p className="">{submenu.title}</p>
                                  </li>
                                </Link>
                              ))}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  ) : (
                    <div className="">
                      <div
                        className={
                          id < footerLink.length - 1
                            ? 'pb-6 text-left border-b sm:border-none sm:text-left w-fit'
                            : ''
                        }
                      >
                        <p className="text-lg font-medium text-white">
                          {section.heading}
                        </p>
                        <nav className="mt-4">
                          <ul className="space-y-4 text-sm">
                            {section.submenu &&
                              section.submenu.map((submenu, id) => (
                                // TODO: trovare il modo di cambiare il Link in un a tag
                                // per l'ultimo elemento dell'array
                                <a
                                  href={submenu.href}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <li
                                    id={id}
                                    className={
                                      submenu.icon
                                        ? `mt-3 text-white flex items-center justify-start gap-2`
                                        : `mt-3 text-white`
                                    }
                                  >
                                    {submenu.icon ? (
                                      <span className="w-auto">
                                        {submenu.icon}
                                      </span>
                                    ) : (
                                      ''
                                    )}
                                    <p className="">{submenu.title}</p>
                                  </li>
                                </a>
                              ))}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  )
                )
              : footerLinkEn.map((section, id) =>
                  id < footerLink.length - 1 ? (
                    <div className="">
                      <div
                        className={
                          id < footerLink.length - 1
                            ? 'pb-6 text-left border-b sm:border-none sm:text-left w-fit'
                            : ''
                        }
                      >
                        <p className="text-lg font-medium text-white">
                          {section.heading}
                        </p>
                        <nav className="mt-4">
                          <ul className="space-y-4 text-sm">
                            {section.submenu &&
                              section.submenu.map((submenu, id) => (
                                // TODO: trovare il modo di cambiare il Link in un a tag
                                // per l'ultimo elemento dell'array
                                <Link to={submenu.href}>
                                  <li
                                    id={id}
                                    className={
                                      submenu.icon
                                        ? `mt-3 text-white flex items-center justify-start gap-2`
                                        : `mt-3 text-white`
                                    }
                                  >
                                    {submenu.icon ? (
                                      <span className="w-auto">
                                        {submenu.icon}
                                      </span>
                                    ) : (
                                      ''
                                    )}
                                    <p className="">{submenu.title}</p>
                                  </li>
                                </Link>
                              ))}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  ) : (
                    <div className="">
                      <div
                        className={
                          id < footerLink.length - 1
                            ? 'pb-6 text-left border-b sm:border-none sm:text-left w-fit'
                            : ''
                        }
                      >
                        <p className="text-lg font-medium text-white">
                          {section.heading}
                        </p>
                        <nav className="mt-4">
                          <ul className="space-y-4 text-sm">
                            {section.submenu &&
                              section.submenu.map((submenu, id) => (
                                // TODO: trovare il modo di cambiare il Link in un a tag
                                // per l'ultimo elemento dell'array
                                <a
                                  href={submenu.href}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <li
                                    id={id}
                                    className={
                                      submenu.icon
                                        ? `mt-3 text-white flex items-center justify-start gap-2`
                                        : `mt-3 text-white`
                                    }
                                  >
                                    {submenu.icon ? (
                                      <span className="w-auto">
                                        {submenu.icon}
                                      </span>
                                    ) : (
                                      ''
                                    )}
                                    <p className="">{submenu.title}</p>
                                  </li>
                                </a>
                              ))}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  )
                )}
          </div>
        </div>

        <div className="pt-6 mt-12 border-t border-gray-100">
          <div className="text-center sm:flex sm:justify-between sm:text-left">
            <p className="text-sm text-gray-500">
              <span className="block mx-4 sm:inline">
                Tutti i diritti riservati
              </span>

              <Link
                className="inline-block text-teal-600 underline transition hover:text-teal-600/75"
                to="/privacy"
              >
                Privacy Policy
              </Link>
            </p>

            <p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0">
              &copy; 2025 eDriveLab srl
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
